<template src="utils/vue/components/complex/cart/re-shopping-cart/template.pug" lang="pug"></template>

<script>
import ReShoppingCart from 'utils/vue/components/complex/cart/re-shopping-cart/script.js'
import GmhCartList from './gmh-cart-list'
import GmhCartBilling from './gmh-cart-billing'
import GmhCartEmpty from './gmh-cart-empty'

export default {
    name: 'gmh-shopping-cart',

    mixins: [
        ReShoppingCart
    ],

    components: {
        GmhCartList,
        GmhCartBilling,
        GmhCartEmpty,
    },

    computed: {
        showCartStep() {
            return this.showCartOrBillingStep || this.showFinalStep
        },
        showBillingStep() {
            return this.showCartOrBillingStep
        },
        showCartOrBillingStep() {
            return (
                this.isCustomCartStep('cart') ||
                this.isCustomCartStep('billing') ||
                (
                (this.cartStep === 'cart' || this.cartStep === 'billing') &&
                !this.currentCartIsEmpty
                )
            )
        },
    },
}
</script>
